<ngx-spinner 
  name="login-loader"
  zIndex="10000000"
  bdColor="rgb(6, 27, 46)"
  size="large"
  color="#fff"
  type="ball-scale-multiple"
  template="<img src='../../assets/img/branding/facilityGuardLoderV2.gif' />"
  [fullScreen]="true">
</ngx-spinner>
